export default __webpack_public_path__ + "static/media/title_vi_pc.0f28134a.png";